import { createFileRoute } from "@tanstack/react-router";
import { WandSparklesIcon } from "lucide-react";
import { ToolRequestList } from "@/components/admin/tool-requests/tool-request-list";
import { requireAdminSection } from "@/lib/admin-guard";

export const Route = createFileRoute("/_admin/tool-requests")({
  beforeLoad: ({ context }) => requireAdminSection(context.auth.capabilities, "tool_requests"),
  component: AdminToolRequestsPage,
});

function AdminToolRequestsPage() {
  return (
    <div className="flex flex-1 flex-col gap-8 p-6">
      <header className="flex flex-col gap-2">
        <div className="flex items-center gap-2 font-medium text-muted-foreground text-xs uppercase tracking-wider">
          <WandSparklesIcon className="size-3.5" />
          Support
        </div>
        <div className="flex flex-col gap-1">
          <h1 className="font-heading font-semibold text-3xl tracking-tight">Tool requests</h1>
          <p className="max-w-2xl text-muted-foreground text-sm">
            Document generators users have asked for through the in-app “Request a tool” dialog.
            Triage each one — plan it, mark it completed once the tool ships, or decline it.
          </p>
        </div>
      </header>

      <ToolRequestList />
    </div>
  );
}
